import React, { useState,  useCallback, useMemo, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ToastContainer } from "react-toastify";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useLocation, useNavigate } from "react-router-dom";
import marketingHubService from "../../Services/MarketingHubService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";

const UpdateTextAndImageTemplate = () => {
  const location = useLocation();
  const editor = useRef(null);


    const { groupId, templateId ,template } = location.state || {};
    const [title, setTitle] = useState(template.title || "");
    const [content, setContent] = useState(template.content || "");
    const [subject, setSubject] = useState(template.subject || "");

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const userId = userObj?.user?.uid;
  const navigate = useNavigate();


  const handleBack = () => {
    navigate(-1);
  };

  const handleUpdateTemplate = async () => {
    if (!title || !content || !subject) {
      showErrorToast("All fields are required. Please fill all the fields.");
      return;
    }
    const templateData = {
      title,
      content,
      subject,
      group: groupId,
      templateId: template.templateId,
      modifiedBy: userId,
    };

    try {
      const response = await marketingHubService.updateTextAndImageTemplate(
                templateData
      );
      if (response.status === 200) {
        navigate(-1);
      }
      if(userRole === "Admin"){

        navigate(-1, {
          state: { message: "Template Updated Successfully" },
        });
      }else if(userRole === "CMO"){

        navigate(-1, {
          state: { message: "Template Updated Successfully" },
        });
      }    } catch (error) {
      console.log(error.message);
      showErrorToast(
        error.message || "An error occurred while updating the template."
      );
    }
  };


  const toolbarOptions = useMemo(
    () => [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      ["link", "image"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["clean"],
    ],
    []
  );

  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await marketingHubService.createImageTemplate(formData);
      if (response.status === 200) {
        return response.data.imageUrl;
      }
    } catch (error) {
      showErrorToast("Image upload failed. Please try again.");
      console.error(error);
    }
  };

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        const imageUrl = await handleImageUpload(file);
        if (imageUrl) {
          const quill = editor.current.getEditor();
          const range = quill.getSelection();
          quill.insertEmbed(range.index, "image", imageUrl);
        }
      }
    };
  }, []);

  const module = useMemo(
    () => ({
      toolbar: {
        container: toolbarOptions,
        handlers: {
          image: imageHandler,
        },
      },
    }),
    [toolbarOptions, imageHandler]
  );
  return (
    <div className="bg-appGrayBackground pb-10 pt-14">
       <AdminAppBar />
      <ToastContainer />
      <div className="mt-14 px-20 xl:px-6 relative flex justify-between gap-5">
        <div className="flex gap-6">
          <svg
            onClick={handleBack}
            className="cursor-pointer"
            width="20"
            height="34"
            viewBox="0 0 22 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
              fill="#399E79"
            />
          </svg>
          <div>
            <h1 className="text-4xl font-semibold whitespace-nowrap">
              Update Text & Image Template
            </h1>
          </div>
        </div>
        <div>
          <button
            onClick={handleUpdateTemplate}
            className="border-2 whitespace-nowrap border-customGreen rounded-sm p-1 px-5 w-fit text-lg text-customGreen h-10 text-center"
          >
            Update Template
          </button>
        </div>
      </div>

      <div className="w-10/12 mx-20 mt-5">
        <div className="w-full px-10 py-5 bg-white shadow-md rounded-md">
          <form className="flex flex-col gap-5">
            <div className="flex items-center">
              <label
                className="w-1/4 text-gray-700 text-xl font-medium"
                htmlFor="name"
              >
                Template Title
              </label>
              <input
                className="shadow appearance-none bg-gray-100 border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="name"
                type="text"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="flex items-center">
              <label
                className="w-1/4 text-gray-700 text-xl font-medium"
                htmlFor="subject"
              >
                Subject
              </label>
              <div className="w-full p-4 rounded-md">
              <input
                className="shadow appearance-none bg-gray-100 border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="subject"
                type="text"
                required
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
              </div>
            </div>

            <div className="text-center font-medium">
              Note: Subject will be used as heading in SMS and WhatsApp.
            </div>

            <div className="flex items-start gap-4">
              <label className="text-xl w-1/4 text-gray-700 font-medium">
                Main Content
              </label>
              <div className="w-full p-4 rounded-md">
                <ReactQuill
                ref={editor}
                  value={content}
                  modules={module}
                  onChange={setContent}
                  theme="snow"
                  placeholder="Your Content"
                  className="w-full"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateTextAndImageTemplate;
